
























import { Component, Prop, Vue } from 'vue-property-decorator';
import { Competency, CompetencySelection } from '@/models/competency/competency';
import { EvalSetting } from '@/models/evalSetting/eval-setting';
import { evalSettingModule } from '@/store/modules/entities/eval-setting.module';
import { GPageBase } from '@/mixins';
import { mixins } from 'vue-class-component';

@Component({
  name: 'GCustomCompetencySelection',
  computed: {},
  methods: {},
})
export default class GCustomCompetencySelection extends mixins(GPageBase) {
  @Prop() title: string;
  @Prop() competencySelection: number[];
  @Prop() competenciesIncludeIsValid: Competency[];
  @Prop() isDisable: boolean;

  mounted() {}

  get evalSettingDetail(): EvalSetting {
    return evalSettingModule.evalSettingDetail;
  }

  get isRequireToSelectCompetencies(): boolean {
    return this.evalSettingDetail.selfEvalRequired || this.evalSettingDetail.giftRequired;
  }
}
